import React, { FC } from 'react';
import Head from 'next/head';

import AutoplayVideo from '../AutoplayVideo';
import LazyToggleContent from '../LazyToggleContent';

import useWithinSizeList from '../../hooks/useWithinSizeList';
import useIntersection from '../../hooks/useIntersection';

import { SIZE_SM, SIZE_MD } from '../../utils/screens';

const USE_MOBILE_SIZING_LIST = [SIZE_SM, SIZE_MD];

interface Props {
  className?: string;
  videoClassName?: string;
  video?: string;
  mobileVideo?: string;
  image?: string;
  mobileImage?: string;
  mobileSizeList?: string[];
  preload?: boolean;
  priority?: boolean;
}

const LazyVideo: FC<Props> = ({
  className,
  videoClassName,
  video,
  mobileVideo,
  image,
  mobileImage,
  mobileSizeList = USE_MOBILE_SIZING_LIST,
  preload = false,
  priority = false,
}) => {
  const [inViewRef, inView] = useIntersection({
    triggerOnce: true,
    rootMargin: '100px 0px',
    initialInView: priority,
    skip: priority,
  });
  const isMobile = useWithinSizeList(mobileSizeList);
  const videoSrc = isMobile ? mobileVideo || video : video || mobileVideo;
  const posterSrc = isMobile ? mobileImage || image : image || mobileImage;

  // Note: `video` exists in the preloading spec, but it is not yet supported in browsers.  Therefore preload the poster.
  return (
    <div ref={inViewRef}>
      {preload && posterSrc && (
        <Head>
          <link as="image" href={posterSrc} key={`__nimg-${posterSrc}`} rel="preload"></link>
        </Head>
      )}
      <LazyToggleContent show={priority || inView}>
        <AutoplayVideo
          className={className}
          // @ts-expect-error
          poster={posterSrc}
          // @ts-expect-error
          src={videoSrc}
          videoClassName={videoClassName}
        />
      </LazyToggleContent>
    </div>
  );
};

export default LazyVideo;
